import classNames from "classnames";
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ScrollView } from "../ScrollView";
import styles from "./index.module.css";

interface IProps {
  className?: string;
  children: string;
}

export const ArtifactMarkdown = React.memo(
  function ArtifactMarkdown(props: IProps) {
    return (
      <div className={classNames(styles.wrapper, props.className)}>
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            pre: ({ children }) => (
              <ScrollView>
                <pre className={styles.pre}>{children}</pre>
              </ScrollView>
            ),
            code: ({ children }) => (
              <code className={classNames(styles.code)}>{children}</code>
            ),
            h1: ({ children }) => <h1 className={styles.h1}>{children}</h1>,
            h2: ({ children }) => <h2 className={styles.h2}>{children}</h2>,
            h3: ({ children }) => <h3 className={styles.h3}>{children}</h3>,
            h4: ({ children }) => <h4 className={styles.h4}>{children}</h4>,
            h5: ({ children }) => (
              <p className={styles.paragraph}>{children}</p>
            ),
            h6: ({ children }) => (
              <p className={styles.paragraph}>{children}</p>
            ),
            p: ({ children }) => <p className={styles.paragraph}>{children}</p>,
            strong: ({ children }) => (
              <strong className={styles.strong}>{children}</strong>
            ),
            blockquote: ({ children }) => (
              <blockquote className={styles.blockquote}>{children}</blockquote>
            ),
            hr: ({}) => <hr className={styles.hr} />,
            ul: ({ children }) => <ul className={styles.ul}>{children}</ul>,
            ol: ({ children }) => <ul className={styles.ul}>{children}</ul>,
            a: ({ children, href }) => {
              const safeHref =
                href?.startsWith("javascript:") || href?.startsWith("data:")
                  ? undefined
                  : href;
              return (
                <a
                  href={safeHref}
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {children}
                </a>
              );
            },
            table: ({ children }) => (
              <div className={styles.tableWrapper}>
                <div className="ant-table">
                  <div className="ant-table-container">
                    <div className="ant-table-content">
                      <table className={styles.table}>{children}</table>
                    </div>
                  </div>
                </div>
              </div>
            ),
            thead: ({ children }) => (
              <thead className={styles.thead}>{children}</thead>
            ),
            tbody: ({ children }) => (
              <tbody className={styles.tbody}>{children}</tbody>
            ),
            tr: ({ children }) => <tr className={styles.tr}>{children}</tr>,
            th: ({ children }) => (
              <th className={styles.th}>
                <div className="ant-table-column-title">{children}</div>
              </th>
            ),
            td: ({ children }) => <td className={styles.td}>{children}</td>,
          }}
        >
          {props.children}
        </ReactMarkdown>
      </div>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.children === nextProps.children;
  }
);
